export default __webpack_public_path__ + "static/media/vote.8cf7bf2e.svg";